import { NotificationType } from '@sg/graphql-schema';

import { type Params } from './useNotificationType.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useNotificationType = () => {
  return getNotificationType;
};

// ─────────────────────────────────────────────────────────────────────────────

function getNotificationType(params: Params) {
  if (!params.canTrackOrderStatus) {
    return;
  }

  return NotificationType.Push;
}
